import { FC, ReactNode } from 'react';

import { Alert, AlertProps, Snackbar } from '@mui/material';

type WaveUINotificationBarProps = {
  message: string;
  severity: AlertProps['severity'];
  open: boolean;
  timeout?: number;
  close?: () => void;
  renderMessage?: (title: ReactNode) => ReactNode;
};

const WaveUINotificationBar: FC<WaveUINotificationBarProps> = ({
  message,
  severity,
  timeout = 5000,
  open,
  close,
  renderMessage,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={timeout}
      onClose={close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity={severity} sx={{ width: '100%' }} onClose={close}>
        {renderMessage ? renderMessage(message) : message}
      </Alert>
    </Snackbar>
  );
};

export default WaveUINotificationBar;
